<template>
  <svg
    :height="height"
    :width="width"
    id="Layer_1"
    style="enable-background:new 0 0 501.551 501.551;"
    version="1.1"
    viewBox="0 0 501.551 501.551"
    x="0px" y="0px"
    xml:space="preserve"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    >
    <path style="fill:#F2F2F2;" d="M480.653,0H20.898C9.404,0,0,9.404,0,20.898v459.755c0,11.494,9.404,20.898,20.898,20.898h459.755
      c11.494,0,20.898-9.404,20.898-20.898V20.898C501.551,9.404,492.147,0,480.653,0z"/>
    <rect x="36.571" y="36.571" style="fill:#87CEEB" width="428.408" height="345.861"/>
    <path style="fill:#334A5E;" d="M261.224,382.433H36.571v-87.771c17.763-5.224,37.616-7.314,57.469-7.314
      c25.078,0,50.155,4.18,71.053,12.539c6.269,2.09,11.494,4.18,16.718,7.314C218.384,323.918,246.596,350.041,261.224,382.433z"/>
    <path style="fill:#40596B;" d="M464.98,271.673v110.759H127.478c9.404-29.257,29.257-55.38,55.38-76.278
      c42.841-34.482,103.445-55.38,172.408-55.38C393.927,250.776,432.588,258.09,464.98,271.673z"/>
    <g>
      <circle style="fill:#FFFFFF;" cx="122.253" cy="122.253" r="42.841"/>
      <path style="fill:#FFFFFF;" d="M433.633,101.355c1.045-3.135,1.045-6.269,1.045-9.404c0-16.718-13.584-31.347-31.347-31.347
        c-11.494,0-21.943,6.269-27.167,15.673c-3.135-2.09-7.314-2.09-11.494-2.09c-14.629,0-26.122,10.449-28.212,24.033
        c-8.359,2.09-14.629,9.404-14.629,17.763c0,10.449,8.359,18.808,18.808,18.808h82.547c10.449,0,18.808-8.359,18.808-18.808
        C441.992,109.714,438.857,104.49,433.633,101.355z"/>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
